import { LISTING_WIZARD_STEPS } from "ui/modules/sales/pages/listings/components/ListingEditCard/consts";

import { ListingIntroChannel, ListingStepText } from "./types";

/** Naslov i objašnjenje ispod scene, po koraku čarobnjaka. */
export const LISTING_INTRO_TEXTS: Record<number, ListingStepText> = {
  [LISTING_WIZARD_STEPS.channelPicker]: {
    title: "Objavite vozilo na više oglasnika",
    description: "Odaberite oglasnike na kojima će se oglas pojaviti. Podatke unosite jednom, a za svaki oglasnik ih možete prilagoditi.",
  },
  [LISTING_WIZARD_STEPS.marketplace]: {
    title: "Oglas koji prodaje",
    description: "Naslov, opis, tehnički podaci i oprema popunjeni su iz vozila. Provjerite ih i dopunite ono što je kupcu važno.",
  },
  [LISTING_WIZARD_STEPS.additionalInfo]: {
    title: "Jamstvo, lokacija i kontakt",
    description: "Kupac treba znati gdje je vozilo i koga nazvati. Zadane vrijednosti dolaze iz postavki oglasa.",
  },
  [LISTING_WIZARD_STEPS.pictures]: {
    title: "Fotografije prodaju vozilo",
    description: "Odaberite i poredajte fotografije. Prva fotografija je naslovna na svim oglasnicima.",
  },
  [LISTING_WIZARD_STEPS.price]: {
    title: "Cijena na svakom oglasniku",
    description: "Upišite osnovnu cijenu oglasa. Za pojedini oglasnik cijenu možete prilagoditi zasebno.",
  },
  [LISTING_WIZARD_STEPS.preview]: {
    title: "Oglas je spreman",
    description: "Pogledajte kako će oglas izgledati kupcima. Nakon spremanja objavljuje se na odabranim oglasnicima.",
  },
};

/** Tekst prvog koraka kad se uređuje postojeći oglas. */
export const LISTING_INTRO_EDIT_TEXT: ListingStepText = {
  title: "Uredite oglas",
  description: "Uključite ili isključite oglasnike. Na isključenom oglasniku oglas se više ne prikazuje.",
};

export const LISTING_INTRO_DEFAULT_STEP = LISTING_WIZARD_STEPS.channelPicker;

export const LISTING_INTRO_DEFAULT_IMAGE = "/media/images/vehicles/vehicle-2.png";

/** Najviše oglasnika u popisu scene, da kartica ne preraste svoju visinu. */
export const LISTING_INTRO_MAX_CHANNELS = 4;

/** Oglasnici koji se prikazuju dok nijedan nije odabran. */
export const LISTING_INTRO_SAMPLE_CHANNELS: ListingIntroChannel[] = [
  { id: "sample-marketplace", code: "marketplace", name: "Marketplace" },
  { id: "sample-njuskalo", code: "njuskalo", name: "Njuškalo" },
  { id: "sample-index", code: "index_oglasi", name: "Index oglasi" },
];

/** Primjeri koji se prikazuju dok podatak još nije upisan. */
export const LISTING_INTRO_SAMPLE = {
  vehicleName: "Volkswagen Golf",
  price: 18900,
  specs: "2021 • 64.000 km • Dizel",
  equipment: ["Navigacija", "Parking senzori", "Tempomat", "LED svjetla"],
  warranty: "12 mjeseci",
  location: "Zagreb, Savska cesta 41",
  pictureCount: 12,
};
